export default {
  title: 'Pago de Factura',
  description: 'Tus cuentas Claro agrupadas por servicio.',
  processing: 'Pago en proceso',
  total: 'Total',
  payWithCards: 'Pagar con Visa, Mastercard o AMEX',
  payInvoice: 'Pagar Factura',
  payWithClave: 'Pagar con Clave',
  payWithBtc: 'Pagar con Bitcoin'
};
